import { Card, CardBody, Col, ListInlineItem, Row } from "reactstrap";
import { Btn, H5, P } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { HorizontalTimelineTitle, ReadMore } from "../../../Constants/Constants";
import { HorizontalTimelineData, HorizontalTimelineSubTitle } from "../../../Data/BonusUi/Timeline";

const HorizontalTimeline = () => {
  return (
    <Col xxl="8" xl="7" className="box-col-12">
      <Card>
        <CommonCardHeader title={HorizontalTimelineTitle} span={HorizontalTimelineSubTitle} />
        <CardBody>
          {HorizontalTimelineData.map((data) => (
            <Row className={`list-inline events timeline-list ${data.mainClass}`} key={data.id}>
              {data.child.map((item) => (
                <Col xxl="4" className={item.colClass} key={item.id}>
                  <div>
                    {item.verticalLine2 && <div className={item.verticalLine2}></div>}
                    <ListInlineItem className="event-list">
                      <div className="px-4">
                        <div className={`event-date alert-light-${item.color} txt-${item.color}`}>{item.date}</div>
                        <H5>{item.header} </H5>
                        <P className="f-light text-truncate">{item.paragraph}</P>
                        <div className="read-more-btn">
                          <Btn color="primary" className="px-3">
                            {ReadMore}
                          </Btn>
                        </div>
                      </div>
                    </ListInlineItem>
                    {item.verticalLine1 && <div className={item.verticalLine1}></div>}
                  </div>
                </Col>
              ))}
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default HorizontalTimeline;
